export const environment = {
    production: false,
    configFile: 'assets/config.json',
    firebaseConfig: {
        apiKey: "AIzaSyDBPA8pTUq01OfsZwXymsmn3lQTsZrtzjY",
        authDomain: "narratheque.firebaseapp.com",
        projectId: "narratheque",
        storageBucket: "narratheque.firebasestorage.app",
        messagingSenderId: "715983646421",
        appId: "1:715983646421:web:84a404adbaa77db3a8fc5c",
        measurementId: "G-ZJRYF46F93"
    },
    sentryDsn: 'https://3dbf744356aa6a0bdbe26344da091d62@o4509071542321152.ingest.de.sentry.io/4509083581612112',
    defaultCountry: 'FR',
};
